
import React from 'react'
import Button from './Button'
import { X } from 'react-feather'
import Box from './Box'

/**
 * Alert component.
 * 
 * Themes:
 * 
 * - info
 * - warning
 * - error
 */

export default function Alert({ children, onClose, closeable = false, theme = '', ...props }) {
  return <Box className="Alert" classes={[theme]} {...props}>
    {children}
    {closeable && <Button theme="minimal" icon={X} onClick={onClose} />}
  </Box>
}